import { Box, Typography } from '@mui/material';
import useLocalization from '../../../hooks/useLocalization';
import type { FinpspPayment } from '../../../types/finpsp';
import { formatDate } from '../../../utils/date';

const styles = {
  root: {
    overflowWrap: 'anywhere',
    '& .MuiTypography-root': {
      typography: 'caption',
      lineHeight: 1.8,
    },
  },
};

const FinpspPaymentReference = ({ payment }: { payment: FinpspPayment }) => {
  const { t } = useLocalization();

  return (
    <Box sx={styles.root}>
      <Typography variant='body2' color='text.secondary'>
        {t('finpspReference')}: {payment.orderId}
      </Typography>
      {payment.expires_at && (
        <Typography variant='body2' color='text.secondary'>
          {t('finpspExpiresAt')}: {formatDate(payment.expires_at)}
        </Typography>
      )}
    </Box>
  );
};

export default FinpspPaymentReference;
